import { Section } from '../common/Section'
import { Eyebrow } from '../common/Eyebrow'
import { SplitHeading } from '../animation/SplitHeading'
import { Reveal } from '../animation/Reveal'
import { Button } from '../common/Button'
import { Icon } from '../common/Icon'
import { company } from '../../data/company'

const POINTS = [
  { icon: 'Sprout', title: 'What we make', body: 'Bio-fertilizers, biostimulants, foliar strength and water management — a complete, bio-based input system.' },
  { icon: 'Users', title: 'Who we serve', body: 'Indian farmers and the retailers and distributors who supply them, from orchard to open field.' },
  { icon: 'ShieldCheck', title: 'Why it matters', body: 'Healthy soil biology grows more resilient crops and reduces dependence on harsh chemistry.' },
]

export function BrandIntro() {
  return (
    <Section className="section bg-canvas" containerClassName="grid gap-14 lg:grid-cols-[1fr_1fr] lg:gap-20">
      <div className="lg:sticky lg:top-28 lg:self-start">
        <Eyebrow>Who we are</Eyebrow>
        <SplitHeading
          as="h2"
          text="We work where every crop actually begins — in the living soil."
          className="mt-5 max-w-xl font-display text-h1 font-semibold text-ink"
        />
        <Reveal as="p" className="mt-6 max-w-lg text-lead text-ink-500" y={20}>
          {company.description}
        </Reveal>
        <Reveal className="mt-8" y={16}>
          <Button to="/about" variant="outline" size="md">
            Our story <Icon name="ArrowRight" className="h-4 w-4" />
          </Button>
        </Reveal>
      </div>

      <div className="flex flex-col gap-6">
        <Reveal
          className="relative overflow-hidden rounded-xl border border-brand-200 bg-brand-50/60 p-8"
          y={24}
        >
          <Icon name="Quote" className="h-8 w-8 text-brand-400" />
          <blockquote className="mt-4 font-display text-2xl font-medium leading-snug text-brand-900">
            “{company.philosophy.quote}”
          </blockquote>
          <cite className="mt-4 block text-sm not-italic text-ink-500">— {company.philosophy.author}</cite>
        </Reveal>

        <Reveal className="grid gap-4" stagger={0.12} y={24}>
          {POINTS.map((p) => (
            <div key={p.title} className="flex gap-4 rounded-lg border border-sand-200 bg-white p-6 shadow-soft">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand-600">
                <Icon name={p.icon} className="h-5 w-5" />
              </span>
              <div>
                <h3 className="font-display text-lg font-semibold text-ink">{p.title}</h3>
                <p className="mt-1 text-[0.95rem] leading-relaxed text-ink-500">{p.body}</p>
              </div>
            </div>
          ))}
        </Reveal>
      </div>
    </Section>
  )
}
